itsoftApp.createModule("tabs", function () {
    const module = this;

    class Tabs {
        constructor(container) {
            this.container = container;
            this.duration = 300;
            this.activeClass = '_active';
            this.openingClass = '_opening';
            this.closingClass = '_closing';
            this.initedClass = '_inited';
            this.triggers = this.container.querySelectorAll('.js-tabs-trigger');
            this.blocks = this.container.querySelectorAll('.js-tabs-block');
            this.curTrigger = this.container.querySelector(`.js-tabs-trigger.${this.activeClass}`);
            this.curBlock = this.container.querySelector(`.js-tabs-block.${this.activeClass}`);

            this.init();
        }
    
        setOptions() {
            this.triggers.forEach((el, i) => el.setAttribute('data-tabs-index', i));
            this.blocks.forEach((el) => el.style.animationDuration = `${this.duration * 0.001}s`);
            this.getCurIndexDefault();
        }
    
        getCurIndexDefault() {
            this.curIndex = this.curTrigger.dataset.tabsIndex;
        }
    
        addListenerClick() {
            this.triggers.forEach((el) => el.addEventListener('click', this.onClick));
        }
    
        onClick(e) {
            e.preventDefault();
    
            if (e.currentTarget === this.curTrigger) {
                return;
            }
    
            if (this.curTrigger) {
                this.curTrigger.classList.remove(this.activeClass);
                this.curTrigger = null;
            }
    
            this.curIndex = e.currentTarget.dataset.tabsIndex;
            this.curTrigger = e.currentTarget;
            this.curTrigger.classList.add(this.activeClass);
    
            this.toggleTab();
        }
    
        toggleTab() {
            if (!this.inProggress) {
                this.onClosingStart();
            }
        }
    
        onClosingStart() {
            this.inProggress = true;
            this.container.style.pointerEvents = 'none';
            this.curBlock.classList.add(this.closingClass);
            setTimeout(this.onClosingEnd, this.duration);
        }
    
        onClosingEnd() {
            this.curBlock.classList.remove(this.closingClass);
            this.curBlock.classList.remove(this.activeClass);
            this.curBlock = null;
    
            this.onOpeningStart();
        }
    
        onOpeningStart() {
            this.curBlock = this.blocks[this.curIndex];
            this.curBlock.classList.add(this.openingClass);
            this.curBlock.classList.add(this.activeClass);
    
            setTimeout(this.onOpeningEnd, this.duration);
        }
    
        onOpeningEnd() {
            this.curBlock.classList.remove(this.openingClass);
            this.inProggress = false;
            this.container.style.pointerEvents = '';
        }
    
        bindEvents() {
            this.onClosingEnd = this.onClosingEnd.bind(this);
            this.onOpeningEnd = this.onOpeningEnd.bind(this);
            this.onClick = this.onClick.bind(this);
        }
    
        init() {
            this.bindEvents();
            this.setOptions();
            this.addListenerClick();
    
            this.container.classList.add(this.initedClass);
        }
    }

    module.callback = Tabs;
});


